import { useState } from 'react';

import { nortadaLogger } from '../logger';
import endpoints from '../../../api/endpoints';
import { handleResponseError } from '../../../api/handleResponseError';
import { fetchWithTokenRefresh } from '../../../api/fetchWithTokenRefresh';

import { Privileges, CLIENT_STATUS, GetClientStatus, GetClientStatusProps } from './interfaces';

interface Props {
  initPrivileges: Privileges;
  initClientStatus: CLIENT_STATUS;
}

export const useGetClientStatus = ({ initPrivileges, initClientStatus }: Props) => {
  const [statusLoading, setLoading] = useState<boolean>(false);
  const [statusError, setError] = useState<boolean>(false);
  const [privileges, setPrivileges] = useState<Privileges>(initPrivileges);
  const [clientStatus, setClientStatus] = useState<CLIENT_STATUS>(initClientStatus);

  const handleGetClientStatus: GetClientStatus = async ({ onFailure, onSuccess }: GetClientStatusProps) => {
    try {
      setLoading(true);
      setError(false);

      const response = await fetchWithTokenRefresh(endpoints.clientStatus);

      if (response.status !== 200) {
        await handleResponseError(response);
      }

      const jsonResponse = await response.json();

      const responsePrivileges: Privileges = {
        api: jsonResponse.apiPrivileges || [],
        portal: jsonResponse.portalPrivileges || []
      };

      setPrivileges(responsePrivileges);
      setClientStatus(jsonResponse.status);
      setLoading(false);

      if (onSuccess) {
        onSuccess(jsonResponse.status);
      }
    } catch (e) {
      nortadaLogger.error(e);
      setLoading(false);
      setError(true);

      if (onFailure) {
        onFailure();
      }
    }
  };

  return { privileges, clientStatus, statusLoading, statusError, handleGetClientStatus };
};
